import { useQuery } from '@tanstack/react-query';
import { createChallengeProgramService } from '../services/challenge-program.service';
import { PaginationParams } from '../types/common';

const CHALLENGE_PROGRAMS_KEY = 'challenge-programs';

export const useChallengePrograms = (
  organizationId: string, 
  challengeId: string, 
  params?: PaginationParams
) => {
  const challengeProgramService = createChallengeProgramService(organizationId, challengeId);

  return useQuery({
    queryKey: [CHALLENGE_PROGRAMS_KEY, organizationId, challengeId, params],
    queryFn: () => challengeProgramService.findAll(params).then((res) => res.data),
    enabled: !!organizationId && !!challengeId
  });
}; 